<template>
  <section class="section__mercedes">
    <!-- Floating case study on right top -->
    <!-- <FloatingCaseStudy :caseColor="caseColor" :caseText="caseText"></FloatingCaseStudy> -->
    <!-- All animating objects -->
    <div class="section__mercedes--bg">
      <div class="section__mercedes--scene">
        <img
          id="car1"
          src="https://ik.imagekit.io/intervi/tr:bl-7/car_mercedes_1_BygDvZC7DE.png"
          data-src="https://ik.imagekit.io/intervi/car_mercedes_1_BygDvZC7DE.png"
          class="lazyload"
          alt="Mercedes 1"
        />
        <img
          id="car2"
          src="https://ik.imagekit.io/intervi/tr:bl-7/car_mercedes_2_H1GrvZ0XD4.png"
          data-src="https://ik.imagekit.io/intervi/car_mercedes_2_H1GrvZ0XD4.png"
          class="lazyload"
          alt="Mercedes 2"
        />

        <div id="hand" class="hand">
          <div class="hand__box">
            <div class="hand__box--img">
              <img
                src="https://ik.imagekit.io/intervi/tr:w-800,bl-7/phone-hand_r1uIW0QvE.png"
                data-src="https://ik.imagekit.io/intervi/tr:w-800/phone-hand_r1uIW0QvE.png"
                class="lazyload"
                alt="Phone hand"
              />
            </div>
            <div class="hand__box--circles">
              <div class="ellipse"></div>
              <div class="ellipse"></div>
              <div class="ellipse"></div>
              <div class="ellipse">
                <div class="circle"></div>
              </div>
              <div class="ellipse">
                <div class>
                  <img
                    class="lazyload"
                    src="https://ik.imagekit.io/intervi/tr:bl-7/mercedes-circle_BylsD-CXP4.png"
                    data-src="https://ik.imagekit.io/intervi/mercedes-circle_BylsD-CXP4.png"
                    alt="Mercedes icon"
                    data-aos="fade-up"
                  />
                </div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
              <div class="ellipse">
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
              <div class="ellipse">
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
              <div class="ellipse">
                <div class="circle"></div>
              </div>
            </div>
            <div class="hand__box--dashes">
              <div class="dash" v-for="i in 100" :key="i"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from "@/components/small-components/SectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";

export default {
  name: "ComponentMercedes",
  data() {
    return {};
  },
  props: {
    showChild: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    this.mouseMove();
  },
  methods: {
    mouseMove: function() {
      $(document).mousemove(function(event) {
        $("#hand").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 60,
            ease: Power1.easeOut
          });
        });

        //  $("#car1").each(function(index, element) {
        //   var xPos = event.clientX / $(window).width() - 0.5,
        //     yPos = event.clientY / $(window).height() - 0.5,
        //     box = element;

        //   TweenLite.to(box, 1, {
        //     x: xPos * 20,
        //     ease: Power1.easeOut
        //   });
        // });

        $("#car2").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * -40,
            ease: Power1.easeOut
          });
        });
      });
    }
  },
  // Init components
  components: {
    SectionTitle: SectionTitle,
    FloatingSocials: FloatingSocials
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentMercedes.vue